module.exports = __webpack_public_path__ + "img/avatar-default.5231a193.png";